module.exports = __webpack_public_path__ + "img/info.164253f7.svg";